'use client';

/**
 * ReadViewContext: true inside a read-only form region (the lot drawer's view
 * mode), where a text field shows its value as text rather than as a disabled
 * input (BL-2842). A disabled input has no innerText and reads as "unavailable"
 * to assistive tech and to the QA agent; the value is a fact the operator reads.
 */

import { createContext, useContext } from 'react';

const ReadViewContext = createContext(false);

/**
 * A read value's type: 16px weight 500 on the phone, 14px from `md` (768px) up (BL-2620).
 * The one copy of this string, shared by the item form's read cells, the Lotting rows and TextInput's read view.
 */
export const READ_VALUE_TEXT = 'text-body-lg md:text-body font-medium text-gray-900';

/** A view-mode value cell: plain text at the row height (BL-2620). The one copy of this string. */
export const READ_VALUE_CLASSES = `flex min-h-11 items-center ${READ_VALUE_TEXT} sm:min-h-9`;

/** Provider: wrap a read-only region so text fields inside render as text. */
export const ReadViewProvider = ReadViewContext.Provider;

/**
 * @returns Whether the calling field sits inside a read-only region.
 */
export function useReadView(): boolean {
  return useContext(ReadViewContext);
}
